var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_24521",
    "data-name": "Group 24521",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32751",
    "data-name": "Path 32751",
    d: "M8.333,0H41.667A8.333,8.333,0,0,1,50,8.333V41.667A8.333,8.333,0,0,1,41.667,50H8.333A8.333,8.333,0,0,1,0,41.667V8.333A8.333,8.333,0,0,1,8.333,0Z",
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-sweep",
    "data-name": "Icon material-delete-sweep",
    d: "M27.916,29h7.667v3.833H27.916Zm0-15.333H41.333V17.5H27.916Zm0,7.667h11.5v3.833h-11.5Zm-23,11.5A3.845,3.845,0,0,0,8.75,36.666h11.5a3.845,3.845,0,0,0,3.833-3.833V13.667H4.917ZM26,7.917H20.25L18.333,6H10.667L8.75,7.917H3V11.75H26Z",
    transform: "translate(2.834 3.667)",
    fill: "#ff0700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.f12292924079d3cb997bd747d91c6b90.svg";
export { ForwardRef as ReactComponent };